module.exports = __webpack_public_path__ + "static/media/8OLA8.db199bae.jpg";